exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".submit-button-section{margin-top:30px;display:flex;justify-content:flex-end}.text-require-notice{font-size:.8rem;color:var(--coredarkcolor)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ca5a3094","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/employers/applications/FamilyFormEdit.vue
// module id = 766
// module chunks = 0